export const selectUser = (state) => state.auth.auth_info;
export const selectAuthInfo = ((state) => state.auth.auth_info);
export const isLoading = (state) => state.auth.isAuthenticated;
export const isAuthenticated = (state) => state.auth.isAuthenticated;